import { saveSettings } from '@capital-access/common/user';
import { LicenseAgreementPreferences } from '../models/license-agreement-preferences';

export const saveLicenseAgreementPreferences = (preferenceSection: string, data: LicenseAgreementPreferences) =>
  saveSettings(LicenseAgreementPreferences, { section: preferenceSection, data });
